module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-category-header">\n    <div class="fmcy-category-name">'+
((__t=( category.name ))==null?'':__t)+
'</div>\n</div>\n<div class="fmcy-category-sub-categories"></div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/category-text-menu/category/category.html
 ** module id = 446
 ** module chunks = 1 27 28 99 111
 **/